import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ClientTransactionUpdateModalUI from './ClientTransactionUpdateModalUI.js'

class ClientTransactionUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      category: null,
      categoryError: null,
    }
  }

  render() {
    return (
      <ClientTransactionUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        category={this.state.category}
        onCategoryChange={(event) => { this.setState({ category: event.target.value }) }}
        categoryError={this.state.categoryError}
        setCategoryError={(error) => { this.setState({ categoryError: error }) }}
        categoryList={this.props.categoryList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    let selectedTxn = this.props.selectedTxn
    if (!selectedTxn) {
      return
    }
    if (prevProps.selectedTxn && prevProps.selectedTxn.analyzerCategory == selectedTxn.analyzerCategory)
      return
    this.setState({category: this.props.selectedTxn.analyzerCategory})
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/clientTransactions/${this.props.selectedTxn.transactionId}/categories`,
      this.onSubmitCallback, {
        category: this.state.category,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
  }
}

export default withRouter(ClientTransactionUpdateModalSF)
